module.exports = __webpack_public_path__ + "img/icon-calendar-event.9704afe8.svg";